import type { BasicFetch } from '../types/basicFetch';
import { concatByteArrays } from '../util/byteArray';
import { fetchByteRange } from './fetchByteRange';
import { inspectMoov } from './inspectMoov';
import type { Mp4Info } from './mp4Types';
import { tryGetMoovBox } from './parser';

export async function fetchAndInspectMoov(
  fetch: BasicFetch,
  url: string,
  // If mp4Info is not undefined, the data from the newly fetched moov will
  // be incorporated into it
  mp4Info: Mp4Info | undefined,
  ignoreVideo: boolean,
  ignoreAudio: boolean,
): Promise<Mp4Info> {

  const getBytes = async (offset: number, size: number): Promise<Uint8Array> => {
    return await fetchByteRange(fetch, url, offset, size);
  };
  return inspectMoovBytes(getBytes, url, mp4Info, ignoreVideo, ignoreAudio);
}

export async function inspectMoovBytes(
  getBytes: (offset: number, size: number) => Promise<Uint8Array>,
  url: string,
  mp4Info: Mp4Info | undefined,
  ignoreVideo: boolean,
  ignoreAudio: boolean,
) {
  let currentStart = 0;
  let bytes = await getBytes(currentStart, 100000);
  while (true) {
    const result = tryGetMoovBox(bytes);
    if (result.type === 'error') {
      throw result.error;
    }
    if (result.type === 'ok') {
      return inspectMoov(mp4Info, result.moov, url, ignoreVideo, ignoreAudio);
    }

    if (result.type === 'incomplete-moov-box') {
      const end = result.moovBoxEnd;
      const additionalBytes = await getBytes(currentStart + bytes.length, currentStart + end);
      bytes = concatByteArrays([bytes, additionalBytes]);
    }

    if (result.type === 'moov-not-found') {
      bytes = await getBytes(result.nextBoxStart, result.nextBoxStart + 10000);
      currentStart = result.nextBoxStart;
    }
  }
}
